import React, { useEffect, useRef, useState } from 'react'
import Loader from '../../components/common/Loader';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Postdata } from '../../helpers/api.service';
import HttpService from '../../helpers/httpServices';
import { message } from '../../redux/actions/toastActions';
import Title from '../../components/common/Title';
import { Topbar } from '../../components/include/Topbar';
import dayjs from 'dayjs';
import HiOutlineDotsVertical from "../../assets/Icons/HiOutlineDotsVertical.svg";
import DeleteModal from '../../components/common/DeleteModal';
import { isPermission, isRole } from '../../redux/selectors/authSelector';
import Error403Page from '../ErrorPage';


const Department_main = () => {
    const [modalOpenDelete, setmodalOpenDelete] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [openMenuIndex, setOpenMenuIndex] = useState(null);
    const [data, setData] = useState([]);
    const navigate = useNavigate();
    const menuRefs = useRef([]);
    const dispatch = useDispatch();
    const [refresh, setRefresh] = useState(false);
    const [loader, setLoader] = useState(false);
    const [modalOpenDeleteSuccess, setModalOpenDeleteSuccess] = useState(false);
    const permissions = useSelector(isPermission);
    const role = useSelector(isRole)
    console.log("permissions", permissions)
    const isAccessible = role == "schooladmin" || permissions && permissions?.includes('view_Department') || false;
    const addPermission = role == "schooladmin" || permissions && permissions?.includes('edit_Department') || false;
    const deletePermission = role == "schooladmin" || permissions && permissions?.includes('delete_Department') || false;

    const toggleMenu = (index) => {
        setOpenMenuIndex(openMenuIndex === index ? null : index);
    };

    const handleDelete = (id) => {
        setLoader(true)
        Postdata(HttpService.department_delete, { id: id }).then((res) => {
            if (res.status === 200) {
                setRefresh(!refresh);
            }
            else {
                dispatch(message(res.message));
            }
            setLoader(false)
        });
        setOpenMenuIndex(null);
    }

    const handleStatusChange = (id, status) => {
        setLoader(true)
        Postdata(HttpService.department_status, { id: id, status: status }).then((res) => {
            if (res.status === 200) {
                setRefresh(!refresh);
                setOpenMenuIndex(null);
            }

            dispatch(message(res.message));
            setLoader(false)
        });
    }

    const fetchData = () => {
        setLoader(true);
        Postdata(HttpService.department_list).then((res) => {
            if (res.status === 200) {
                setData(res.data);
            } else {

                dispatch(message(res.message));
            }
            setLoader(false)
        }).catch((e) => {
            setLoader(false);
            dispatch(message(e.message));
        });;
    }
    useEffect(() => {
        fetchData();
    }, [refresh])


    // Close menu on outside click
    useEffect(() => {
        const handleClickOutside = (event) => {
            let clickedInside = false;
            menuRefs.current.forEach(ref => {
                if (ref && ref.contains(event.target)) {
                    clickedInside = true;
                }
            });
            if (!clickedInside) {
                setOpenMenuIndex(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    if (!isAccessible) {
        return (
            <>
                <Error403Page />
            </>
        );
    }


    if (loader) {
        return <Loader isClass="loader_fullscreen" />
    }
    return (
        <div>
            <Title name="Department" />
            <Topbar title="Department" btn={addPermission || false} btnName="+Add" btnLink="/department/add" />
            <div className='p-6 space-y-6 pr-0'>
                <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3'>

                    {data.length > 0 && data.map((item, index) =>
                    (
                        // <div className={` rounded-lg bg-white ${item.status == 0 ? ' border-gray-400  opacity-40' : ''} `} key={index}>
                        //     <img className='w-full h-60 object-cover  mb-2' onClick={() => navigate(`/department/view/${item._id}`)} src={item.image} />
                        //     <div className=" relative flex justify-between text-gray-800   mx-auto">
                        //         <div>
                        //             <h3 className="text-sm font-semibold pt-[10px] pl-[10px] ml-2">
                        //                 {item.title}
                        //             </h3>
                        //             <h3 className="text-sm text-gray-400 font-normal px-[10px] ml-2">
                        //                 {dayjs(item.createdAt).format("DD MMM YYYY")}
                        //             </h3>

                        //         </div>
                        //       {(addPermission || deletePermission ) &&  <div className='bg-white '>
                        //             <div className="absolute top-3 right-3 ">
                        //                 <button onClick={() => toggleMenu(index)}>
                        //                     <img
                        //                         src={HiOutlineDotsVertical}
                        //                         className="text-black-500 hover:text-black"
                        //                     />
                        //                 </button>

                        //                 {openMenuIndex == index && (
                        //                     <div ref={(el) => (menuRefs.current[index] = el)} className="absolute right-5 bottom-0 w-20 bg-white shadow-md border rounded-xl z-10">
                        //                       {addPermission &&  <button
                        //                             className="block w-full text-left px-3 rounded-b-xl py-2 text-sm hover:bg-gray-100"
                        //                             onClick={() => handleStatusChange(item._id, item.status)}
                        //                         >
                        //                             {item.status ? "Inactive" : "Active"}
                        //                         </button>}
                        //                        {addPermission && <button
                        //                             className="block w-full text-left px-3 rounded-b-xl py-2 text-sm hover:bg-gray-100"
                        //                             onClick={() => navigate(`/department/edit/${item._id}`, { state: { type: "edit" } })}
                        //                         >
                        //                             Edit
                        //                         </button>}
                        //                       { deletePermission&& <button
                        //                             onClick={() => {
                        //                                 setSelectedId(item._id);
                        //                                 setmodalOpenDelete(true);
                        //                             }}
                        //                             className="block w-full text-left px-3 rounded-b-xl py-2 text-sm hover:bg-gray-100"
                        //                         >
                        //                             Delete
                        //                         </button>}
                        //                     </div>
                        //                 )}
                        //             </div>

                        //         </div>}
                        //     </div>
                        // </div>
                        <div
                            className="rounded-lg bg-white shadow-md border relative"
                            key={index}
                        >
                            <img
                                className="w-full h-60 object-cover mb-2 cursor-pointer"
                                onClick={() => navigate(`/department/view/${item._id}`)}
                                src={item.image}
                                alt={item.title}
                            />

                            <div className="relative flex justify-between text-gray-800 mx-auto px-3 pb-3">
                                <div>
                                    <h3 className="text-sm font-semibold pt-[10px]">
                                        {item.title}
                                    </h3>
                                    <h3 className="text-sm text-gray-400 font-normal">
                                        {dayjs(item.createdAt).format("DD MMM YYYY")}
                                    </h3>

                                    {/* Just plain text for status */}
                                    <p className={`text-sm font-medium mt-1 ${item.status === 1 ? "text-green-600" : "text-red-500"}`}>
                                        {item.status === 1 ? "Active" : "Inactive"}
                                    </p>
                                </div>

                                {(addPermission || deletePermission) && (
                                    <div className="bg-white">
                                        <div className="absolute top-3 right-3">
                                            <button onClick={() => toggleMenu(index)}>
                                                <img
                                                    src={HiOutlineDotsVertical}
                                                    className="w-5 h-5 text-gray-600 hover:text-black"
                                                    alt="options"
                                                />
                                            </button>

                                            {openMenuIndex === index && (
                                                <div
                                                    ref={(el) => (menuRefs.current[index] = el)}
                                                    className="absolute right-0 mt-2 w-28 bg-white shadow-md border rounded-xl z-10"
                                                >
                                                    {addPermission && (
                                                        <button
                                                            className="block w-full text-left px-3 py-2 rounded-t-xl text-sm hover:bg-gray-100"
                                                            onClick={() => handleStatusChange(item._id, item.status)}
                                                        >
                                                            {item.status === 1 ? "Deactivate" : "Activate"}
                                                        </button>
                                                    )}
                                                    {addPermission && (
                                                        <button
                                                            className="block w-full text-left px-3 py-2 text-sm hover:bg-gray-100"
                                                            onClick={() => navigate(`/department/edit/${item._id}`, { state: { type: "edit" } })}
                                                        >
                                                            Edit
                                                        </button>
                                                    )}
                                                    {deletePermission && (
                                                        <button
                                                            onClick={() => {
                                                                setSelectedId(item._id);
                                                                setmodalOpenDelete(true);
                                                            }}
                                                            className="block w-full text-left px-3 py-2  rounded-b-xl text-sm hover:bg-gray-100"
                                                        >
                                                            Delete
                                                        </button>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    )
                    )}
                    <DeleteModal
                        title="Delete Department"
                        message="Are you sure you want to delete Department?
It will erase all the data permanently."
                        modalOpenDelete={modalOpenDelete}
                        setmodalOpenDelete={setmodalOpenDelete}
                        handleDelete={handleDelete} // Don't call it here
                        selectedId={selectedId}
                        setSelectedId={setSelectedId}
                        modalOpenDeleteSuccess={modalOpenDeleteSuccess}
                        setModalOpenDeleteSuccess={setModalOpenDeleteSuccess}
                        module={"Department"}
                        redirectPage={"Department"}
                        redirectUrl={'/department'}
                    />
                </div>
                {
                    data.length === 0 && <div className="h-[50vh] flex items-center justify-center w-full">
                        <h1 className="text-center text-gray-400">No Data Found</h1>
                    </div>
                }
            </div>
        </div>
    )
}

export default Department_main